export default {
  // 加载状态
  loadingHistory: "正在加载会话内容...",

  // 房间和用户信息
  aiAssistant: "AI助手",
  aiAssistantXiaoTu: "AI助手--小图",
  you: "您",
  today: "今天",
  online: "在线",

  // 欢迎语
  welcomeConsult: "欢迎咨询AI助手",
  welcomeMessageRobot: "您好，我是AI助手--小图。<br/>请问有什么可以帮助您的？",
  welcomeMessageFull: `您好！我是智能助手小图。我融合了大模型的先进AI能力与图链在虚拟币犯罪追踪与风险防控领域的深厚实战经验，致力于为您提供专业的虚拟货币安全与合规支持和产品使用指南。
 您可以问我有任何关于：
• 画布操作快捷键有哪些？
• 画布支持哪些币种分析？
• 如何创建案件？
• 如何识别虚拟币风险？
• 可疑交易模式分析？
• 链上追踪基础知识？
• ...（其他具体产品功能操作问题或其他虚拟货币犯罪、风控、合规、链上分析相关问题）`,

  // 聊天组件文本
  textMessages: {
    roomsEmpty: "没有对话",
    roomEmpty: "没有选择对话",
    newMessages: "新消息",
    messageDeleted: "此消息已被删除",
    messagesEmpty: "没有消息",
    conversationStarted: "对话开始于：",
    typeMessage: "请输入您要提问的内容...",
    search: "搜索",
    isOnline: "欢迎咨询AI助手",
    lastSeen: "最后一次上线 ",
    isTyping: "正在输入...",
  },

  // 初始问候消息
  initialGreeting: "您好，我是AI助手。<br/>请问有什么可以帮助您的？",
};
